import config from '../../config';

export const assetUrl = (path) => `${process.env.PUBLIC_URL || ''}${path}`;

export const getAdminUrl = (path) => {
  const baseUrl = config.endpoints.baseAdminUrl || '';
  return `${baseUrl}${path}`;
};

export const cx = (...classes) => classes.filter(Boolean).join(' ');
